export default function ($translateProvider) {
	'ngInject';

	$translateProvider
		.translations('bg', {
			'NEGOTIATED': {
				'CHOOSE': 'Моля изберете автобус',
				'BUS_NUMBER': 'Автобус №: ',
				'LINE': 'Линия:',
				'LABEL': 'Договорени места',
				'USER': 'Потребител',
				'LABEL_RESERVATION': 'Резервация на места',
				'CONFIRM_MESSAGE': 'Всички направени промени ще бъдат записани. Сигурни ли сте?',
				'BUTTON': {
					'CLEAR': 'Изтрий резервациите на '
				},
				'ERROR': {
					'USER_ERROR': 'Моля изберете потребител',
					'BUS_NUMBER': 'Моля изберете автобус',
					'OCUPIED_SEAT': 'Това мяста е вече запазено за ',
					'NO_SEATS_SELECTED': 'Нямата избрани места. Моля изберете поне едно място',
					'NO_RESERVATONS': 'няма резервирани места!'
				},
				'SUCCESS': {
					'RESERVATION_CREATED': 'Успешно резервирахте избраните места',
					'SEATS_DELETED': 'Успешно изтрихте резервираните места'
				},
				'HINT': 'Преди да запишете резервация можете да запазите места за повече от един потребител.'				
			}
		})
		.translations('en', {
			'NEGOTIATED': {
				'CHOOSE': 'Please choose bus',
				'BUS_NUMBER': 'Bus №: ',
				'LINE': 'Line:',
				'LABEL': 'Agreed seats',
				'USER': 'User',
				'LABEL_RESERVATION': 'Seats reservation',
				'CONFIRM_MESSAGE': 'All changes will be saved. Are you sure?',
				'BUTTON': {
					'CLEAR': 'Clear reservation of '
				},
				'ERROR': {
					'USER_ERROR': 'Please choose user',
					'BUS_NUMBER': 'Please choose bus',
					'OCUPIED_SEAT': 'This place is already reserved for ',
					'NO_SEATS_SELECTED': 'No selected seats. Please select at least one seat!',
					'NO_RESERVATONS': 'has no reserved seats!'				
				},
				'SUCCESS': {
					'RESERVATION_CREATED': 'Selected seats are successfully reserved',
					'SEATS_DELETED': 'Reserved seats are successfilly deleted.'
				},
				'HINT': 'Before save a reservation , you can reserve seats for more than one user'
			}

		});
}



/** WEBPACK FOOTER **
 ** ./client/private/negotiated-seats/negotiated-seats.locale.js
 **/